import { useSearchParams, Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import GameBoard from '../../components/game/GameBoard';
import type { Difficulty } from '../../utils/mathProblems';

const VALID_LEVELS: Difficulty[] = ['easy', 'medium', 'hard', 'expert'];

export default function VolumeChallenge() {
  const [params] = useSearchParams();
  const levelParam = params.get('level') as Difficulty | null;
  const difficulty: Difficulty = levelParam && VALID_LEVELS.includes(levelParam) ? levelParam : 'easy';

  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <section className="relative pt-24 pb-6 px-6 bg-teal-900 text-white">
        <div className="max-w-4xl mx-auto flex items-center justify-between flex-wrap gap-3">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <div className="w-8 h-8 flex items-center justify-center bg-teal-400 rounded-full">
                <i className="ri-box-3-line text-teal-900 text-lg" />
              </div>
              <h1 className="text-2xl font-bold" style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.05em' }}>
                VOLUME CHALLENGE
              </h1>
            </div>
            <p className="text-teal-300 text-sm">3D shape volume calculations · Best of 3 sets</p>
          </div>
          <Link
            to="/level-selector"
            className="text-sm text-teal-300 hover:text-teal-200 cursor-pointer flex items-center gap-1 whitespace-nowrap"
          >
            <i className="ri-settings-3-line" />
            Change Level
          </Link>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 py-8">
        <GameBoard challengeType="volume" difficulty={difficulty} />
      </section>

      <Footer />
    </div>
  );
}
